// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"401":"b48a24fa","624":"3cca0eb6","969":"a8fcccb4","985":"bf355423"}[chunkId] + ".css";
};